import rootSortConfig from './roots-sort.config'

export default [
  ...rootSortConfig,
  {
    title: 'ID по возрастанию',
    field: 'id.asc',
    options: {
      by: 'id',
      order: 'asc'
    }
  },
  {
    title: 'ID по убыванию',
    field: 'id.desc',
    options: {
      by: 'id',
      order: 'desc'
    }
  },
  {
    title: 'Артикул (А-Я)',
    field: 'article.asc',
    options: {
      by: 'article',
      order: 'asc'
    }
  },
  {
    title: 'Артикул (Я-А)',
    field: 'article.desc',
    options: {
      by: 'article',
      order: 'desc'
    }
  },
]